const prefix = 'ldSeating-'
const maxAge = 60 * 60 * 24 * 90

export function useUpdateLanguage() {
  const { locale } = useI18n()

  const isLanguageBarHidden = useCookie(prefix + 'hideLanguageBar', {
    default: () => false,
    maxAge,
  })

  const browserLanguage = computed(() => {
    if (import.meta.server) {
      const headers = useRequestHeaders(['accept-language'])

      return (
        headers['accept-language']?.split(',')[0]?.split('-')[0] ||
        headers['accept-language']?.split(',')[0] ||
        'en'
      )
    }
    return navigator.language.split('-')[0] || navigator.language
  })

  const isUpdateLanguageBarShown = computed(
    () =>
      !isLanguageBarHidden.value &&
      (((browserLanguage.value === 'cs' || browserLanguage.value === 'sk') &&
        locale.value !== 'cs') ||
        (browserLanguage.value === 'fr' && locale.value !== 'fr') ||
        (browserLanguage.value === 'de' && locale.value !== 'de') ||
        (browserLanguage.value === 'en' && locale.value !== 'en') ||
        (browserLanguage.value !== 'cs' &&
          browserLanguage.value !== 'sk' &&
          browserLanguage.value !== 'fr' &&
          browserLanguage.value !== 'de' &&
          locale.value !== 'en'))
  )

  function hideLanguageBar() {
    isLanguageBarHidden.value = true
    console.log('hide language bar')
  }

  return {
    isUpdateLanguageBarShown,
    browserLanguage,
    hideLanguageBar,
  }
}
